import React from "react";

interface KeyValueListProps {
  data: [string, string | number][];
}

export const KeyValueList: React.FC<KeyValueListProps> = ({ data }) => {
  return (
    <ul className="list-disc list-inside p-0 m-0">
      {data.map(([key, value], index) => (
        <li key={index} className="grid gap-4 pt-1 pb-1 grid-cols-[1fr_2fr]">
          <span className="text-dark-gray">{key}:</span>
          <span>{value}</span>
        </li>
      ))}
    </ul>
  );
};
